

// Import Icon
import Iconclock from "../../../assets/img/icon/clock.png"
import IconMap from "../../../assets/img/icon/map.png"
import IconDate from "../../../assets/img/icon/date.png"




export const UpcomingEventsData = [
 
  {
    heading:"Badminton club night — all levels welcome",
    category:"#Badminton",
    para:`Our regular hall sessions: warm-up, drills, and games. Loan rackets often available; newcomers get a friendly welcome.`,
    IconClock:Iconclock,
    IconMap:IconMap,
    IconDate:IconDate
  },
  {
    heading:"Integration coffee & Q&A — schools & summer plans",
    category:"#Integration",
    para:`An informal session for parents on navigating school communication, activities, and holiday planning in Sweden—with peers and PCF leads.`,
    IconClock:Iconclock,
    IconMap:IconMap,
    IconDate:IconDate
  },
  {
    heading:"Seasonal social — cricket taster on the grass",
    category:"#Cricket",
    para:`Outdoor meet-up when the season allows: soft-ball cricket, picnic, and sign-up info for our next football or swim block.`,
    IconClock:Iconclock,
    IconMap:IconMap,
    IconDate:IconDate
  }
   
]
